<template>
<article class="page-box flex">
  <!-- 左面板视图 -->
  <section class="left-panel">
    <div class="search-section">
      <lz-icon type="iconfont" name="lzicon-search_outline icon" :size="15" @click.native="handleSearchClick"></lz-icon>

      <el-input class="search-input" clearable :placeholder="$t('搜索系统名称')" v-model="searchKeyword" @keydown.enter.native="handleSearchClick" @clear="handleSearchClear"></el-input>
    </div>

    <div class="content-section mt-10">
      <div class="head-view flex">
        <lz-icon type="iconfont" name="lzicon-spherical" :size="16" color="#497CF6"></lz-icon>
        <p>{{$t('选择系统')}}</p>
      </div>

      <ul class="list-view">
        <template v-for="i in projectList">
          <li :class="{ selected: i.projectCode === activeProjectCode }" :key="i.projectCode" @click="handleItemClick(i)">
            {{i.projectCode}}
          </li>
        </template>
      </ul>
    </div>
  </section>

  <!-- 右面板视图 -->
  <section class="right-panel">
    <div class="title-section">
      <img src="~@/assets/images/authority-icon.png" alt=""/>
      <span>{{$t('设置该角色权限')}}</span>
    </div>

    <div class="content-section">
      <RoleTree ref="boxRefView" :title="activeProjectCode" @emitCheck="renderCheck"></RoleTree>
    </div>
  </section>
</article>
</template>

<script>
import RoleTree from './RoleTree.vue'

export default {
  name: 'SelectPermission',
  components: { RoleTree },
  props: {
    roleType: String,
    hotelVid: String,
  },
  data () {
    return {
      allIds: {}, // 所有 项目 的 id
      proPer: {}, // 选中项目 对应的选中权限
      ppData: [], // 项目权限数据
      projectData: [], // 项目数据源
      permissionAll: [], // 选中 项目 下的权限 数据
      // selectedPerIds: [], // 选中的 权限 id
      searchKeyword: '',
      isSearching: false,
      isEdit: '',
      activeProjectCode: '', // 当前选中的项目 编码
    }
  },
  computed: {
    // 项目列表
    projectList () {
      if (this.isSearching) {
        return this.projectData.filter(f => {
          return f.projectName.toLowerCase().indexOf(this.searchKeyword.trim().toLowerCase()) !== -1;
        })

      } else {
        return this.projectData;
      }
    },
  },
  methods: {
    /**
     *@Description 查询 .
     *@Return
     **/
    handleSearchClick () {
      if (this.searchKeyword.trim()) {
        this.isSearching = true;
      }
    },
    handleSearchClear () {
      this.isSearching = false;
    },
    /**
     *@Description 全选、清空 事件 监听 .
     *@Return
     **/
    renderCheck (ls) {
      // this.selectedPerIds = ls // 选中的 权限 id
      const vas = this.allIds[this.activeProjectCode]
      const arr = []
      vas.forEach(i => {
        if(ls.includes(i)) {
          arr.push(i)
        }
      })

      this.proPer[this.activeProjectCode] = arr
      console.log('render Check:', this.proPer, ls)
    },
    /**
     *@Description 编辑 通过 check 查 id  .
     *@Return
   **/
    recursiveDownEditCheck (list) {
      let checks = []

      list.forEach(i => {
        if (i.checked) {
          checks.push(i.resourceId)
        }
        if (i.children?.length > 0) {
          const childChecks = this.recursiveDownEditCheck(i.children);
          checks.push(...childChecks);
        }
      })

      return checks
    },
    /**
     *@Description 左侧 项目 点击 事件  .
     *@Return
     **/
    handleItemClick (d) {
      const code = d.projectCode

      if (code !== this.activeProjectCode) {
        this.activeProjectCode = code

        const obj = this.projectData.find(i => i.projectCode === code) || {}
        this.permissionAll = obj.resources || []
        this.$refs.boxRefView.setBoxData(obj);
      }
    },
    /** 外部调用 **/
    /**
     *@Description 设置 数据 fetch  .
     *@Return
     **/
    setData (data, t) {
      this.isEdit = t ? 'edit' : 'add'
      this.projectData = data || []
      // 初始默认数据加载逻辑：
      // - 通用角色：第一个系统权限数据
      // - 门店角色：第一个非 disabled 系统权限数据
      // - “复制角色” 需初始化所有系统权限数据，以备直接提交保存

      console.log('初始数据：', data)

      let arr = []
      if(this.isEdit === 'edit') {
        const o = {}
        data?.forEach(i => {
          if(i.resources?.length > 0) {
            const ids = this.recursiveDownEditCheck(i.resources)
            if(ids.length > 0) {
              arr = [ ...arr, ...ids ]
              o[i.projectCode] = ids
            }
          }
        })
        console.log('编辑 回显：', o)

        this.proPer = { ...o }
      }

      for (let i = 0; i < data.length; i++) {
        const obj = data[i]
        if (this.activeProjectCode) {
          continue;
        }

        if (!this.activeProjectCode) {
          this.activeProjectCode = obj.projectCode;
          this.permissionAll = obj.resources || []

          this.$refs.boxRefView.setBoxData(obj, arr);
        }
      }

      this.allIds = this.transformResources(this.projectData)
    },
    // ===========
    transformResources (data) {
      // 初始化结果对象
      const result = {};

      // 递归收集所有resourceId的函数
      function collectResourceIds(resources, ids) {
        if (!resources || !Array.isArray(resources)) return;
        resources.forEach(resource => {
          // 收集当前资源的resourceId
          ids.push(resource.resourceId);
          // 递归处理子资源
          collectResourceIds(resource.children, ids);
        });
      }

      // 遍历每个项目
      data.forEach(project => {
        const { projectCode, resources } = project;
        const resourceIds = [];
        // 收集当前项目下所有资源的id
        collectResourceIds(resources, resourceIds);
        // 存入结果对象
        result[projectCode] = resourceIds;
      });

      return result;
    },
    //============
    /**
     *@Description 获取 已配置的 项目 权限数据  .
     * @note 新增、编辑时，权限字段数据只需传被点击渲染过的系统权限信息；复制时，需传所有系统权限信息
     *@Return
     **/
    getSelData () {
      const tmpData = []
      const keys = Object.keys(this.proPer)

      keys.forEach(i => {
        const v = this.proPer[i]
        if(v.length > 0) {
          tmpData.push({
            projectCode: i,
            resourceIds: v
          })
        }
      })
      console.log('已选权限:', tmpData)

      return tmpData
    },
    /**
     * 校验是否产生编辑行为
     * @returns { Boolean } true/false
     */
    checkIfTreeEdit () {
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/const";
@import "@/style/mixins";
.page-box {
  justify-content: space-between;
}
.left-panel {
  width: 280px;
  height: 100%;

  // 搜索板块
  .search-section {
    $_height: 30px;

    height: 32px;
    border: 1px solid $border-color;
    border-radius: 2px;

    .icon {
      width: $_height;
      height: $_height;
      line-height: $_height;
      color: $theme-color;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
    }

    .search-input {
      width: calc(100% - 30px);
      vertical-align: top;

      ::v-deep .el-input__inner {
        border: none;
        height: $_height;
        line-height: $_height;
      }

      ::v-deep .el-input__icon {
        line-height: $_height;
      }
    }
  }
}
// 内容板块
.content-section {
  height: calc(100vh - 240px);
  .head-view {
    padding: 6px 0;
    font-size: 16px;
    p {
      padding-top: 1px;
      margin-left: 8px;
    }
  }

  .list-view {
    height: calc(100% - 40px);
    overflow: auto;
    li {
      height: 40px;
      line-height: 40px;
      padding-left: 22px;
      cursor: pointer;
      @include no-wrap-single;
      &:hover {
        background-color: #EDF3FF;
      }
    }
    .selected {
      color: $theme-color;
    }
  }
}

.right-panel {
  width: calc(100% - 300px);
  height: 100%;

  .title-section {
    padding-bottom: 16px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
      vertical-align: middle;
    }
    span {
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
